module.exports = __webpack_public_path__ + "static/media/raum_neuro_ortho.3a7a0894.jpg";